import React from 'react';

const Sponsors = () => {
  return (
    <section className="sponsors section">
      <div className="sponsors-container bd-grid">
        <div className="sponsors-logo">
          <img src="https://i.postimg.cc/3Jv5TRsx/logo1.png" alt="image logo" />
        </div>

        <div className="sponsors-logo">
          <img src="https://i.postimg.cc/bJBWXcLn/logo2.png" alt="image logo" />
        </div>

        <div className="sponsors-logo">
          <img src="https://i.postimg.cc/J0HgM6d2/logo3.png" alt="image logo" />
        </div>

        <div className="sponsors-logo">
          <img src="https://i.postimg.cc/xjkTX9wW/logo4.png" alt="image logo" />
        </div>
      </div>
    </section>
  );
};

export default Sponsors;

